<div class="signup__page">
  <div class="main--wrapper">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="signup--header">
            <div class="signup--headerImage" [ngClass]="{'text-center':signUpDone }">
              <a role="button" [href]="commonService.landingUrl">
                <img
                  [src]="commonService?.getOrgWindowObject?.LOGO_URL ? commonService?.getOrgWindowObject?.LOGO_URL : 'assets/images/logo.png'"
                  onerror="this.src='assets/images/logo.png';" alt="Valzy" class="img-fluid cursor-pointer">
              </a>
            </div>
          </div>
        </div>
      </div>
      <form autocomplete="off" #signUpForm="ngForm" novalidate="novalidate" (submit)="signUp()">
        <ng-container *ngIf="signUpDone; else showSignUpForm">
          <div class="position-relative">
            <div class="blueish-bg hide-background">
              <div class="shade upper"></div>
              <div class="shade lower"></div>
            </div>
            <div class="signup--content">
              <div class="signup--contentBox success-box">
                <div>
                  <svg-icon name="email_sent"></svg-icon>
                </div>
                <div class="mt-50 mb-10">
                  <h4 class="signup--contentTitle mb-0" *ngIf="!isDemo">Check your email</h4>
                  <h4 class="signup--contentTitle mb-0" *ngIf="isDemo">You have been added to the waitlist.</h4>
                </div>
                <div class="font-size-12 color--gray" *ngIf="!isDemo">
                  We sent an email to <span class="color--black">{{EMAIL}}</span> with a link to activate your
                  account.<br/>
                </div>
                <div class="font-size-12 color--gray" *ngIf="isDemo">
                  <span>
                    We are not accepting any new users at this time.<br/>
                    Please contact <a href="mailto:support@valzy.com">support&#64;valzy.com</a> if you have any questions.<br/>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-template #showSignUpForm>
          <div class="row signup--row">
            <div class="col-12 col-sm-12 col-md-7 col-lg-7 position-relative">
              <div class="blueish-bg hide-background">
                <div class="shade upper"></div>
                <div class="shade lower"></div>
              </div>
              <div class="signup--content">
                <div class="signup--contentBox">
                  <h4 class="signup--contentTitle">Sign Up</h4>

                  <!-- User Type -->
                  <div class="mb-15 mt-4"
                       [ngClass]="{'error-block' : (((!userType.valid && !userType.untouched) || signUpForm?.submitted) && (userType.errors?.required)) || error}">
                    <div class="label">I am a(n)…</div>
                    <app-custom-select #userType="ngModel"
                                       [(ngModel)]="USER_TYPE" [values]="userTypeList"
                                       [classes]="userType.errors && (userType.dirty || userType.touched) ? 'error-input-select' : ''"
                                       placeholder="Select Type" name="userType" id="userType" required>
                    </app-custom-select>
                    <div *ngIf="userType.errors && (userType.dirty || userType.touched)">
                      <div class="error-text">Type is required</div>
                    </div>
                  </div>

                  <!-- Other Type -->
                  <div class="mb-15 mt-4" *ngIf="enumBusinessType.OTHER === USER_TYPE"
                       [ngClass]="{'error-block' : (((!OTHER_TYPE.valid && !OTHER_TYPE.untouched) || signUpForm?.submitted) && OTHER_TYPE.errors?.required) || error}">
                    <div class="label">Please Describe</div>
                    <input type="text" class="input input__blue input__large" #OTHER_TYPE="ngModel" autocomplete="new-password"
                           name="OTHER_TYPE" id="OTHER_TYPE" [(ngModel)]="OTHER_USER_TYPE" required placeholder="Describe"
                           [ngClass]="{'error-input': (((!OTHER_TYPE.valid && !OTHER_TYPE.untouched) || signUpForm?.submitted) && OTHER_TYPE.errors?.required) || error}">
                    <ng-container *ngIf="OTHER_TYPE.errors && (OTHER_TYPE.dirty || OTHER_TYPE.touched)">
                      <div class="error-text">Description is required</div>
                    </ng-container>
                  </div>

                  <!-- Lender Bank Name -->
                  <div class="mb-15 mt-4" *ngIf="enumBusinessType.LENDER === USER_TYPE"
                       [ngClass]="{'error-block' : (((!OTHER_TYPE_BANK.valid && !OTHER_TYPE_BANK.untouched) || signUpForm?.submitted) && OTHER_TYPE_BANK.errors?.required) || error}">
                    <div class="label">Bank Name</div>
                    <input type="text" class="input input__blue input__large" #OTHER_TYPE_BANK="ngModel" autocomplete="new-password"
                           name="OTHER_TYPE_BANK" id="OTHER_TYPE_BANK" [(ngModel)]="OTHER_USER_TYPE" required placeholder="Bank Name"
                           [ngClass]="{'error-input': (((!OTHER_TYPE_BANK.valid && !OTHER_TYPE_BANK.untouched) || signUpForm?.submitted) && OTHER_TYPE_BANK.errors?.required) || error}">
                    <ng-container *ngIf="OTHER_TYPE_BANK.errors && (OTHER_TYPE_BANK.dirty || OTHER_TYPE_BANK.touched)">
                      <div class="error-text">Bank Name is required</div>
                    </ng-container>
                  </div>

                  <!-- Email -->
                  <div class="mb-15 mt-4"
                       [ngClass]="{'error-block' : (((!USER_EMAIL.valid && !USER_EMAIL.untouched) || signUpForm?.submitted) && (USER_EMAIL.errors?.required || USER_EMAIL.errors?.pattern)) || error}">
                    <div class="label">Enter Your Email</div>
                    <input type="text" class="input input__blue input__large" #USER_EMAIL="ngModel" maxlength="50"
                           name="USER_EMAIL" id="USER_EMAIL" [(ngModel)]="EMAIL" required placeholder="hello@gmail.com"
                           [pattern]="commonService.emailPattern" autocomplete="new-password"
                           [ngClass]="{'error-input': (((!USER_EMAIL.valid && !USER_EMAIL.untouched) || signUpForm?.submitted) && (USER_EMAIL.errors?.required || USER_EMAIL.errors?.pattern)) || error}"
                           (ngModelChange)="removeErrorMsg()">
                    <!-- ^[_aA-zZ0-9\-\_\+]+(\.[_aA-zZ0-9\-\_\+]+)*@[aA-zZ0-9-\-\_\.]+\.([aA-zZ]{2,15})$ -->
                    <ng-container
                      *ngIf="((!USER_EMAIL.valid && !USER_EMAIL.untouched) || signUpForm?.submitted) && (USER_EMAIL.errors?.required || USER_EMAIL.errors?.pattern)">
                      <div *ngIf="USER_EMAIL.errors?.required" class="error-text">Email is required</div>
                      <div *ngIf="!USER_EMAIL.errors?.required && USER_EMAIL.errors?.pattern" class="error-text">The
                        email you entered isn’t correct. Please check your email.
                      </div>
                    </ng-container>
                    <ng-container *ngIf="error && EMAIL">
                      <div class="error-text">{{error}}</div>
                    </ng-container>
                  </div>

                  <!-- Password -->
                  <div class="mb-15 mt-4"
                       [ngClass]="{'error-block': (txtPassword.errors && (txtPassword.dirty || txtPassword.touched || txtPassword.errors?.pattern))}">
                    <div class="label">Create a Password</div>
                    <div class="wrapper">
                      <input [type]="showEnteredPassword? 'text' : 'password'" class="input input__large input__blue"
                             [(ngModel)]="PASSWORD"
                             pattern="^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$"
                             [ngClass]="{'error-input': (txtPassword.errors && (txtPassword.dirty || txtPassword.touched || txtPassword.errors?.pattern))}"
                             #txtPassword="ngModel" name="txtPassword" maxlength="50" id="txtPassword"
                             autocomplete="new-password"
                             placeholder="****************" required>
                    </div>
                    <div
                      *ngIf="txtPassword.errors && (txtPassword.dirty || txtPassword.touched || txtPassword.errors?.pattern)">
                      <div class="error-text">Password must be at least 8 characters with at least 1 number and 1
                        special character (&#64;, $, !, %, *, #, ?, &)
                      </div>
                    </div>
                  </div>

                  <!-- Captcha -->
                  <div class="row">
                    <div class="col-md-12" *ngIf="captchaVisible">
                      <re-captcha (resolved)="resolved($event)"></re-captcha>
                    </div>
                    <div class="col-md-12">
                      <p class="font-size-14">
                        By registering you agree to our
                        <a class="color--blue" href="/privacy" target="_blank">privacy policy</a>,&nbsp;
                        <a class="color--blue" href="/license" target="_blank">license</a> &
                        <a class="color--blue" href="/tos" target="_blank">terms and conditions</a>
                      </p>
                    </div>
                    <div class="col-md-12">
                      <button type="submit" class="button large__button font-size-18 primary__button w-50">
                        SIGN UP
                      </button>
                    </div>
                  </div>
                </div>
                <div class="signup--loginLink">
                  I already have an account – <a [routerLink]="['/login']">LOG IN</a>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-5 col-lg-5">
              <div class="signup--detailsContent pt-0">
                <h2>Receive your detailed internal business valuation today!</h2>
                <p class="font-size-12 color--gray">By signing up you get:</p>
                <ul>
                  <li>
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M7 14.4375L11.8125 19.25L21 9.625" stroke="#61CD7A" stroke-width="2"
                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <strong>UNLIMITED FREE Express Valuations</strong>
                  </li>
                  <li>
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M7 14.4375L11.8125 19.25L21 9.625" stroke="#61CD7A" stroke-width="2"
                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <strong>FREE Library of Valuation Resources</strong>
                  </li>
                  <li>
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M7 14.4375L11.8125 19.25L21 9.625" stroke="#61CD7A" stroke-width="2"
                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <strong>DETAILED PDF Valuation Report</strong>
                  </li>
                </ul>
                <!-- Discount Badge -->
                <div class="discount-container" *ngIf="PROMO === 'PROMO2024' && USER_TYPE === enumBusinessType.BUSINESS_OWNER">
                  <div class="discount-text">84%<br/>Off</div>
                  <div class="discount-wordings">
                    For a limited time, order an Internal Business Valuation for only <span class="highlight-offer">$39</span> - a savings of <span class="highlight-offer">$210</span>!
                  </div>
                </div>

                <p class="color--gray font-size-12 mt-55">
                  <a href="/pricing" class="on__hover__blue">See our pricing offers</a> for a list of more features that
                  could benefit you.
                  If you have a promo code, just enter and apply it on the checkout page.
                </p>
              </div>
            </div>

          </div>
        </ng-template>
      </form>
    </div>
  </div>
</div>

